import { countBy } from 'lodash';

export const getMostFrequentlyOccurringItem = (items: string[]): string => {
  const counts = countBy(items);
  const maxOccurring = Math.max(...Object.values(counts));
  const mostFrequent = Object.keys(counts).find(k => counts[k] === maxOccurring);

  return mostFrequent === 'null' ? null : mostFrequent;
};
